import React, { useImperativeHandle, useState } from "react";
import EditScreenSelector from "../../Reusables/EditScreenSelector";
import styles from "./CalenderWall_Reusable.module.css";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
import CalenderWallSingleImage from "./CalenderWall_SingleImage";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const CalenderWallReusable = React.forwardRef(
  (
    {
      index,
      totalItems,
      state,
      image_selection_popup,
      changeCopyDetails,
      selectedCopyDetails,
      currentPageNumber,
      totalPageNumber,
    },
    ref
  ) => {
    console.log(state, "state");
    console.log("ON INDEX");
    console.log(index);
    console.log(state);
    console.log(totalItems);
    const [choice, setChoice] = useState(state.selected);
    const [images, setImages] = useState(state.images);
    console.log(images);

    useImperativeHandle(ref, () => ({
      getAllInfo,
    }));
    const getAllInfo = () => {
      return {
        option: choice,
        images: images,
      };
    };

    const uploadImage = (num, id) => {
      if (num === 1) {
        image_selection_popup(index, 1, id);
      } else {
        let imagesLeft = 0;
        console.log("Images length");
        console.log(state.images.length);
        for (let i = 0; i < 4; i++) {
          for (let j = 0; j < 3; j++) {
            if (state.images[i][j].src === "") imagesLeft++;
          }
        }
        if (imagesLeft !== 0) {
          image_selection_popup(index, imagesLeft, -1);
        } else return;
      }
    };

    const handleImageDrop = (draggedItemId, targetItemId) => {
      const tempImages = images.flat();
      const updatedItems = [...tempImages];
      const draggedIndex = tempImages.findIndex(
        (item) => item.id === draggedItemId
      );
      const targetIndex = tempImages.findIndex(
        (item) => item.id === targetItemId
      );

      if (draggedIndex !== -1 && targetIndex !== -1) {
        // Swap the positions of the dragged and target items
        [updatedItems[draggedIndex], updatedItems[targetIndex]] = [
          updatedItems[targetIndex],
          updatedItems[draggedIndex],
        ];
        const resultArray = [];
        let subArrayIndex = 0;

        updatedItems.forEach((item, index) => {
          if (index % 3 === 0) {
            resultArray[subArrayIndex] = [];
            subArrayIndex++;
          }
          resultArray[subArrayIndex - 1].push(item);
        });
        console.log(resultArray);
        setImages(resultArray);
      }
    };

    const cancelImage = (id) => {
      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 3; j++) {
          if (images[i][j].id === id) {
            let temp = [...images];
            temp[i][j].src = "";
            console.log("Removing IMAGE LINK");
            console.log(temp[i][j].src);
            setImages(temp);
            return;
          }
        }
      }
    };

    //new 1
    const copyOptions = [];
    for (let i = 1; i < currentPageNumber; i++) {
      copyOptions.push(i + "個目と同じ");
    }
    copyOptions.push("別のデザインで作る");
    // let copySelected =
    //   selectedCopyDetails === currentPageNumber
    //     ? currentPageNumber + "個目の写真"
    //     : selectedCopyDetails+"個目の写真";
    let copySelected = selectedCopyDetails + "個目の写真";
    const extractNumber = (s, currentPageNumber, totalPageNumber) => {
      for (let i = totalPageNumber; i > 0; i--) {
        if (s.includes(i)) {
          return i;
        }
      }
      return currentPageNumber;
    };
    console.log("Page info");
    console.log(currentPageNumber);
    console.log(totalPageNumber);

    return (
      <div className={styles.main_div}>
        <div className={styles.header_div_main_wrapper}>
          <div className={styles.header_section_main}>
            {currentPageNumber === 1 && (
              <div name="写真選択" className={styles.header_section}>
                写真選択
              </div>
            )}

            {totalPageNumber > 1 && (
              <div
                className={styles.header_number}
                name={"editsection" + currentPageNumber}
              >
                {currentPageNumber + "個目"}
              </div>
            )}
          </div>
          <div className={styles.selection_main_div}>
            {currentPageNumber > 1 && (
              <div className={styles.multi_page_selector_wrapper}>
                <div className={styles.multi_page_selector}>
                  <EditScreenSelector
                    takeupspace={true}
                    options={copyOptions}
                    callback={(value) => {
                      console.log(value);
                      changeCopyDetails(
                        extractNumber(
                          value,
                          currentPageNumber,
                          totalPageNumber
                        ),
                        index
                      );
                      // changeState("sec03textbox", value);
                      // setSec03textbox(value);
                    }}
                    selected={copySelected}
                  />
                </div>
              </div>
            )}
            {selectedCopyDetails === currentPageNumber && (
              <>
                <div className={styles.selection_main_head1_text}>
                  1. カレンダーの開始月を選択してください。　
                </div>

                <div className={styles.option_main}>
                  <EditScreenSelector
                    selected={choice}
                    options={["1月始まり", "4月始まり", "9月始まり"]}
                    callback={(value) => {
                      //   changeState("sec03textbox", value);
                      setChoice(value);
                    }}
                  />
                </div>

                <div className={styles.option_blue_text}>
                  ※納期に1ヶ月頂戴しますので、始まり月は余裕を持って設定してください。
                </div>

                <div className={styles.selection_main_head1_text2}>
                  2. 写真を12枚選択してください。
                </div>
                <div
                  onClick={(event) => {
                    uploadImage(0);
                  }}
                  className={styles.upload_image_placeholder}
                >
                  <img
                    className={styles.upload_image_gallery_icon}
                    src={gallery_icon}
                    alt="top_gallery"
                  />

                  <div className={styles.upload_image_placeholder_text}>
                    写真選択
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        {selectedCopyDetails === currentPageNumber && (
          <>
            <div className={styles.title_hr}></div>
            <div className={styles.gallery_header_main_div}>
              <div className={styles.gallery_header_01}>カレンダー</div>
              <div className={styles.gallery_header_02}>
                {choice === "9月始まり"
                  ? "9月〜翌年8月"
                  : choice === "4月始まり"
                  ? "4月〜翌年3月"
                  : "1月〜12月"}
              </div>
            </div>
            <div className={styles.images_main}>
              <DndProvider backend={HTML5Backend}>
                <div className={styles.grid_container}>
                  {images.flat().map((item, index) => (
                    <CalenderWallSingleImage
                      src={item.src}
                      key={index}
                      photoID={item.id}
                      index={index}
                      cancelImage={cancelImage}
                      handleImageDrop={handleImageDrop}
                      uploadSingle={uploadImage}
                    />
                  ))}
                </div>
              </DndProvider>
            </div>
          </>
        )}
        {selectedCopyDetails !== currentPageNumber && (
          <div className={styles.bottom_hr99}></div>
        )}
      </div>
    );
  }
);
export default CalenderWallReusable;
